module.exports = __webpack_public_path__ + "static/media/Adjustment Factors.f2e42a58.pdf";